export const ROUTES = {
  MARKETPLACE: '/app-gallery',
  APPLICATION: '/app-gallery/:id',
  EMBED: '/app-gallery/embed',
};
